<template>
	<section class="section-base form-section-base">
		<div class="form-section-base__title">Параметры заявления</div>
		<v-container>
			<!--  Option 1 --->
			<form v-if="radioGroup === 1" class="form-base">
				<div class="form-section-base__block-outer">
					<div class="form-section-base__block-inner">
						<v-row>
							<v-col cols="12">
								<div class="label-apart">
									1. Срок, когда обязательство должно было быть исполнено (дата или
									условие)
								</div>
								<div class="form-base__tooltip">
									<v-icon small>{{ mdiAlertCircleOutline }}</v-icon>
									<span class="text" v-html="$t('noticeRecovery.params.timeLimitDate.hint')"></span>
								</div>
								<v-radio-group
									v-model="form.section1.orDateCondition"
									class="pt-0"
									hide-details="true"
								>
									<v-row>
										<v-col cols="4" class="section-radio py-0">
											<v-radio value="1" class="mr-3">
												<template v-slot:label>
													<DateFieldCustom
														label="Дата"
														:disabled="form.section1.orDateCondition === '2'"
														:value="$v.form.section1.timeLimitDate.$model"
														:errorMessage="$v.form.section1.timeLimitDate"
														:max="new Date().toISOString()"
														@change="$v.form.section1.timeLimitDate.$model = $event"
														@blur="$v.form.section1.timeLimitDate.$touch"
													/>
												</template>
											</v-radio>
										</v-col>
										<v-col cols="8" class="section-radio py-0">
											<v-radio value="2" class="ml-1">
												<template v-slot:label>
													<div class="d-flex flex-column align-start">
														<v-text-field
															v-model="$v.form.section1.timeLimitCondition.$model"
															:errorMessages="getValidationErrorText($v.form.section1.timeLimitCondition)"
															label="Условие c датой"
															:disabled="form.section1.orDateCondition === '1'"
															outlined
															style="width: 600px; margin-bottom: 16px"
															@blur="$v.form.section1.timeLimitCondition.$touch"
														/>
														<DateFieldCustom
															label="Дата"
															:disabled="form.section1.orDateCondition === '1'"
															:value="$v.form.section1.timeLimitDate.$model"
															:errorMessage="$v.form.section1.timeLimitDate"
															:max="new Date().toISOString()"
															@change="$v.form.section1.timeLimitDate.$model = $event"
															@blur="$v.form.section1.timeLimitDate.$touch"
														/>
													</div>
												</template>
											</v-radio>
										</v-col>
									</v-row>
								</v-radio-group>
							</v-col>
						</v-row>
					</div>
				</div>
				<div class="form-section-base__block-outer">
					<div class="form-section-base__block-inner">
						<v-row>
							<v-col cols="12">
								<div class="label-apart">
									2. Срок, за который производится взыскание
								</div>
								<div class="form-base__tooltip">
									<v-icon small>{{ mdiAlertCircleOutline }}</v-icon>
									<span class="text" v-html="$t('noticeRecovery.params.penaltyLimFrom.hint')"></span>
								</div>
								<v-row>
									<v-col cols="4" class="pb-0 ">
										<DateFieldCustom
											label="Дата"
											:value="$v.form.section1.penaltyLimFrom.$model"
											:errorMessage="$v.form.section1.penaltyLimFrom"
											:min="minDatePenaltyLimFrom"
											:max="new Date().toISOString()"
											@change="$v.form.section1.penaltyLimFrom.$model = $event"
											@blur="$v.form.section1.penaltyLimFrom.$touch"
										/>
									</v-col>
									<v-col cols="1" class="py-0">
										<div class="separator">---</div>
									</v-col>
									<v-col cols="4" class="pb-0">
										<DateFieldCustom
											label="Дата"
											:value="$v.form.section1.penaltyLimTo.$model"
											:errorMessage="$v.form.section1.penaltyLimTo"
											:min="minDatePenaltyLimTo"
											:max="new Date().toISOString()"
											@change="$v.form.section1.penaltyLimTo.$model = $event"
											@blur="$v.form.section1.penaltyLimTo.$touch"
										/>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</div>
				</div>
				<div class="form-section-base__block-outer">
					<div class="form-section-base__block-inner">
						<v-row>
							<v-col cols="12">
								<div class="label-apart">
									3. Сумма, подлежащая взысканию (заполняется при взыскании денежных
									сумм)
								</div>
								<div class="form-base__tooltip">
									<v-icon small>{{ mdiAlertCircleOutline }}</v-icon>
									<span class="text" v-html="$t('noticeRecovery.params.penaltySum.hint')"></span>
								</div>
								<CurrencyField
									class="mt-4"
									v-model="$v.form.section1.penaltySum.$model"
									:readonly="true"
									:disabled="true"
									:errorMessages="
                getValidationErrorText($v.form.section1.penaltySum)
              "
									@blur="$v.form.section1.penaltySum.$touch"
								/>
							</v-col>
							<v-col cols="12" class="pt-0">
								<div class="label-apart pt-0">- сумма основного долга</div>
								<CurrencyField
									v-model="$v.form.section1.penaltyDebt.$model"
									:disabled="isResendToFsspStatement"
									:errorMessages="
                getValidationErrorText($v.form.section1.penaltyDebt)
              "
									@blur="$v.form.section1.penaltyDebt.$touch"
								/>
							</v-col>
							<v-col cols="12" class="pt-0">
								<div class="label-apart pt-0">- сумма процентов</div>
								<CurrencyField
									v-model="$v.form.section1.penaltyPercent.$model"
									:disabled="isResendToFsspStatement"
									:errorMessages="
                getValidationErrorText($v.form.section1.penaltyPercent)
              "
									@blur="$v.form.section1.penaltyPercent.$touch"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" class="pt-0">
								<div class="label-apart pt-0">
									- сумма неустойки (за исключением неустойки по кредитным
									договорам)
								</div>
								<CurrencyField
									v-model="$v.form.section1.penaltyForfeit.$model"
									:errorMessages="
                getValidationErrorText($v.form.section1.penaltyForfeit)
              "
									:disabled="isPenaltyForfeitDisabled || isResendToFsspStatement"
									@blur="$v.form.section1.penaltyForfeit.$touch"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" class="pt-0">
								<div class="label-apart pt-0">
									- сумма расходов, понесенных взыскателем в связи с совершением
									исполнительной надписи
								</div>
								<CurrencyField
									v-model="$v.form.section1.penaltyCosts.$model"
									:errorMessages="
                getValidationErrorText($v.form.section1.penaltyCosts)
              "
									:disabled="isResendToFsspStatement"
									@blur="$v.form.section1.penaltyCosts.$touch"
								/>
							</v-col>
						</v-row>
					</div>
				</div>
				<div class="form-section-base__block-outer">
					<div class="form-section-base__block-inner">
						<v-row>
							<v-col cols="12">
								<div class="label-apart">
									4. Сведения о подлежащем истребованию имуществе и его
									идентифицирующих признаках
								</div>
								<v-textarea
									v-model="$v.form.section1.demandOwn.$model"
									:errorMessages="
                getValidationErrorText($v.form.section1.demandOwn)
              "
									outlined
									@blur="$v.form.section1.demandOwn.$touch"
								/>
							</v-col>
						</v-row>
					</div>
				</div>
				<div class="form-section-base__block-outer">
					<div class="form-section-base__block-inner">
						<v-row>
							<v-col cols="12">
								<div class="label-apart mb-0">
									5. Реквизиты взыскателя для получения денежных средств
								</div>
								<div class="label-apart">наименование получателя (взыскателя)</div>
								<v-text-field
									v-model="$v.form.section1.jdgmntCreditorName.$model"
									:errorMessages="
                getValidationErrorText($v.form.section1.jdgmntCreditorName)
              "
									outlined
									@blur="$v.form.section1.jdgmntCreditorName.$touch"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<LoadAccountBankDetails @change="loadBankDetailFromAccount"/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" class="pt-0">
								<div class="label-apart pt-0">номер счета*</div>
								<v-text-field
									v-model="$v.form.section2.accountNumber.$model"
									v-mask="['####################']"
									:errorMessages="
                getValidationErrorText($v.form.section2.accountNumber)
              "
									outlined
									@blur="$v.form.section2.accountNumber.$touch"
								/>
								<div class="pt-0 pb-4" v-html="$t('noticeRecovery.params.accountNumber.hint')" ></div>
							</v-col>
							<v-col cols="6" class="pt-0">
								<div class="label-apart pt-0">номер корреспондентского счета</div>
								<v-text-field
									v-model="$v.form.section2.corrAccountNumber.$model"
									v-mask="['####################']"
									:errorMessages="
                getValidationErrorText($v.form.section2.corrAccountNumber)
              "
									outlined
									@blur="$v.form.section2.corrAccountNumber.$touch"
								/>
							</v-col>
							<v-col cols="6" class="pt-0">
								<div class="label-apart pt-0">БИК</div>
								<DadataBankField
									v-model="$v.form.section2.bic.$model"
									mask="#########"
									:errorMessages="getValidationErrorText($v.form.section2.bic)"
									outlined
									:suggestions="suggestions"
									field="bic"
									@suggest="onSelect"
									@blur="$v.form.section2.bic.$touch"
								/>
							</v-col>
							<v-col cols="12" class="pt-0">
								<div class="label-apart pt-0">Наименование банка получателя</div>
								<DadataBankField
									v-model="$v.form.section2.bankName.$model"
									:errorMessages="getValidationErrorText($v.form.section2.bankName)"
									outlined
									:suggestions="suggestions"
									field="bankName"
									@suggest="onSelect"
									@blur="$v.form.section2.bankName.$touch"
								/>
							</v-col>
							<v-col cols="6" class="pt-0">
								<div class="label-apart pt-0">ИНН</div>
								<v-text-field
									v-model="$v.form.section2.inn.$model"
									v-mask="['##########']"
									:errorMessages="getValidationErrorText($v.form.section2.inn)"
									outlined
									@blur="$v.form.section2.inn.$touch"
								/>
							</v-col>
							<v-col cols="6" class="pt-0">
								<div class="label-apart pt-0">КПП</div>
								<v-text-field
									v-model="$v.form.section2.kpp.$model"
									v-mask="KPP"
									:errorMessages="getValidationErrorText($v.form.section2.kpp)"
									outlined
									@blur="$v.form.section2.kpp.$touch"
								/>
							</v-col>
						</v-row>
					</div>
				</div>
			</form>
			<!--  End Option 1 --->

			<Footer
				@next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
				@prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
				:loading-next="loadingNext"
			/>
		</v-container>
	</section>
</template>

<script>
import cloneDeep from 'clone-deep';
import deepmerge from 'deepmerge';
import {
	maxLength,
	required,
	requiredIf,
	minLength,
	and,
} from 'vuelidate/lib/validators';
import CurrencyField from '@/components/base/CurrencyField.vue';
import Footer from '@/components/services/elements/Footer';
import {
	CURRENCY_MAX_LENGTH, ACCOUNT_NUMBER_CHECKSUM, 
	CURRENCY_ONLY_POSITIVE,
	DATE_FORMAT,
	DATE_FUTURE,
	DATE_PAST,
	getValidationErrorText,
	MinLength,
	EMOJI,
	INN,
	KPP,
	IS_TWO_YEARS_SINCE_DATE, checkDatePenaltyLimFrom, isDateBeforeOrEquals, TRAILING_AND_LEADING_SPACES
} from '@/utils/validate';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import {ServicesModule} from '@/store/modules/services';
import {checkInvalid, dateFormat, leaveStep} from '@/utils/services';
import {StepDirection, StepName} from '@/types/services';
import LoadAccountBankDetails from '@/components/services/elements/LoadAccountBankDetails';
import {NoticeRecoveryStep} from '@/constants';
import DadataBankField from '@/components/base/DadataBankField';
import {mdiAlertCircleOutline} from "@mdi/js";

export default {
	name: 'JudgementCreditorBankDetails',
	props: {
		loadingNext: {
			type: Boolean,
			required: true,
		},
		isResendToFsspStatement: {
			type: Boolean,
		},
		isAlternativeServiceEdit: {
			type: Boolean,
			required: true,
		},
	},
	components: {
		LoadAccountBankDetails,
		DateFieldCustom,
		Footer,
		CurrencyField,
		DadataBankField,
	},
	validations() {
		let data = {
			tempDate: {
				DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
				IS_TWO_YEARS_SINCE_DATE: IS_TWO_YEARS_SINCE_DATE(this.isResendToFsspStatement),
			},
			form: {
				section1: {
					timeLimitDate: {
						required,
						DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
						IS_TWO_YEARS_SINCE_DATE: IS_TWO_YEARS_SINCE_DATE(this.isResendToFsspStatement),
					},
					timeLimitCondition: {},
					penaltyLimFrom: {
						required,
						DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
						CHECK_DATE_PENALTY_LIM_FROM: checkDatePenaltyLimFrom(this.isResendToFsspStatement, this.form.section1.timeLimitDate)
					},
					penaltyLimTo: {
						required,
						DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST, isDateBeforeOrEquals(this.form.section1.penaltyLimFrom)),
					},
					penaltySum: {
						required,
						CURRENCY_MAX_LENGTH,
					},
					penaltyDebt: {
						required: requiredIf(
							(vm) => vm.penaltyPercent || vm.penaltyForfeit || vm.penaltyCosts
						),
						CURRENCY_MAX_LENGTH,
						CURRENCY_ONLY_POSITIVE,
					},
					penaltyPercent: {
						CURRENCY_MAX_LENGTH,
						CURRENCY_ONLY_POSITIVE,
					},
					penaltyForfeit: {
						CURRENCY_MAX_LENGTH,
						CURRENCY_ONLY_POSITIVE,
					},
					penaltyCosts: {
						CURRENCY_MAX_LENGTH,
						CURRENCY_ONLY_POSITIVE,
					},
					demandOwn: {
						maxLength: maxLength(4000),
						EMOJI,
						TRAILING_AND_LEADING_SPACES
					},
					jdgmntCreditorName: {
						required,
						EMOJI,
						TRAILING_AND_LEADING_SPACES
					},
				},
				section2: {
					accountNumber: {
						minLength: minLength(20),
						ACCOUNT_NUMBER_CHECKSUM: (value) => {
							return ACCOUNT_NUMBER_CHECKSUM(value, this.$v.form.section2.bic.$model)();
						},
					},
					corrAccountNumber: {
						required,
						minLength: minLength(20),
						TRAILING_AND_LEADING_SPACES,
						ACCOUNT_NUMBER_CHECKSUM: (value) => {
							return ACCOUNT_NUMBER_CHECKSUM(value, this.$v.form.section2.bic.$model, true)();
						},
					},
					bic: {
						required,
						minLength: minLength(MinLength.BIC),
						TRAILING_AND_LEADING_SPACES
					},
					bankName: {
						required,
						maxLength: maxLength(255),
						EMOJI,
						TRAILING_AND_LEADING_SPACES
					},
					inn: {
						minLength: minLength(10),
						INN: INN(10),
					},
					kpp: {
						minLength: minLength(9),
						KPP,
					},
				},
			},
		};

		if (this.form.section1.orDateCondition === '1') {
			data.form.section1.timeLimitDate = deepmerge(
				data.form.section1.timeLimitDate,
				{
					required,
				}
			);
		} else {
			data.form.section1.timeLimitCondition = {
				required,
				maxLength: maxLength(1000),
				EMOJI,
				TRAILING_AND_LEADING_SPACES
			};
		}
		return {
			form: data.form,
		};
	},
	data: () => ({
		mdiAlertCircleOutline,
		StepDirection,
		StepName,
		leaveStep,
		getValidationErrorText,
		checkbox: true,
		radioGroup: 1,
		menu: false,
		invalidFields: [],
		suggestions: [],
		// form data
		form: {
			section1: {
				orDateCondition: '1',
				timeLimitDate: '',
				timeLimitCondition: '',
				penaltyLimFrom: '',
				penaltyLimTo: '',
				penaltySum: null,
				penaltyDebt: null,
				penaltyPercent: null,
				penaltyForfeit: null,
				penaltyCosts: null,
				demandOwn: '',
				jdgmntCreditorName: '',
			},
			section2: {
				accountNumber: '',
				corrAccountNumber: '',
				bic: '',
				bankName: '',
				inn: '',
				kpp: '',
			},
			documents: [],
		},
	}),
	computed: {
		penaltySum() {
			return (
				this.form.section1.penaltyDebt +
				this.form.section1.penaltyPercent +
				this.form.section1.penaltyForfeit +
				this.form.section1.penaltyCosts
			);
		},
		minDatePenaltyLimFrom() {
			if (!this.form.section1.timeLimitDate) {
				return null
			}
			const debtCollectionDate = new Date(dateFormat(this.form.section1.timeLimitDate));
			debtCollectionDate.setDate(debtCollectionDate.getDate() + 1);
			return debtCollectionDate.toISOString();
		},
		minDatePenaltyLimTo() {
			if (!this.form.section1.penaltyLimFrom) {
				return null
			}
			return new Date(dateFormat(this.form.section1.penaltyLimFrom)).toISOString();
		},
		isPenaltyForfeitDisabled() {
			return ['002', '005'].includes(this.form.section1.notarialWritCode);
		},
	},
	watch: {
		penaltySum(value) {
			this.$v.form.section1.penaltySum.$model = value;
		},
	},
	created() {
		this.prefillDraft();
	},
	methods: {
		loadBankDetailFromAccount(data) {
			this.form.section2 = cloneDeep(data);
		},
		touchFields() {
			this.invalidFields = [];
			this.$v.$touch();
			checkInvalid(this.$v, this.invalidFields);
		},

		assemblyModel() {
			let ENRDStore = {};
			let JCBDStore = {};

			if (
				ServicesModule.statement &&
				ServicesModule.statement.executiveNoticesRecoveryDetails
			) {
				ENRDStore = {
					...ServicesModule.statement.executiveNoticesRecoveryDetails,
				};
			}
			if (
				ServicesModule.statement &&
				ServicesModule.statement.judgementCreditorBankDetails
			) {
				JCBDStore = {
					...ServicesModule.statement.judgementCreditorBankDetails,
				};
			}

			return {
				executiveNoticesRecoveryDetails: {
					...cloneDeep(ENRDStore),
					...deepmerge(this.form.section1, {
						timeLimitDate:
							this.form.section1.orDateCondition === '1'
								? this.form.section1.timeLimitDate
								: null,
						timeLimitCondition:
							this.form.section1.orDateCondition === '2'
								? this.form.section1.timeLimitCondition
								: null,
					}),
				},
				judgementCreditorBankDetails: {
					...cloneDeep(JCBDStore),
					...cloneDeep(this.form.section2),
				},
				statementParamDocuments: cloneDeep(this.form.documents),
			};
		},

		prefillDraft() {
			let EModelStore = {};
			let JModelStore = {};
			let SPStore = null;

			if (ServicesModule.statement.executiveNoticesRecoveryDetails) {
				EModelStore = cloneDeep(
					ServicesModule.statement.executiveNoticesRecoveryDetails
				);
			}
			if (ServicesModule.statement.judgementCreditorBankDetails) {
				JModelStore = cloneDeep(
					ServicesModule.statement.judgementCreditorBankDetails
				);
			}
			if (ServicesModule.statement.statementParamDocuments) {
				SPStore = [...ServicesModule.statement.statementParamDocuments];
			}

			this.form = {
				section1: {
					...cloneDeep(this.form.section1),
					...cloneDeep(EModelStore),
					orDateCondition: EModelStore.timeLimitCondition ? '2' : '1',
				},
				section2: {
					...cloneDeep(this.form.section2),
					...cloneDeep(JModelStore),
				},
				documents: SPStore ? cloneDeep(SPStore) : [],
			};

			this.$v.$reset();
		},

		btnSaveClickHandler(direction) {
			leaveStep({
				stepThis: this,
				direction,
				step: NoticeRecoveryStep.JUDGEMENT_CREDITOR_BANK_DETAILS,
			});
		},

		onSelect: function (data) {
			this.suggestions = [data];
			this.$v.form.section2.corrAccountNumber.$model = data.corrAccountNumber;
			this.$v.form.section2.bankName.$model = data.bankName;
			this.$v.form.section2.bic.$model = data.bic;
		}
	},
};
</script>

<style scoped lang="scss">
.label-apart {
	margin-right: 20px;
	margin-bottom: 12px;
	padding-top: 18px;
	color: $color-black;
}

.section-radio {
	&::v-deep .v-input--selection-controls__input {
		margin-bottom: 30px !important;
	}
}

.separator {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding-bottom: 20px;
	height: 100%;
}
</style>
